import React, { useEffect, useState } from 'react';
import { Info, Globe } from 'lucide-react';
import services from '../../services';
import ResponsivePagination from "react-responsive-pagination";

export function MessageThread({ taskId }) {
  const [message, setMessage] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const totalPages = Math.ceil(totalCount / limit);
  const getChatsDetails = async () => {
    try {
      const query = new URLSearchParams({ page, limit }).toString();
      const response = await services.task.GET_CHAT_DETAILS(taskId, query);
      setMessage(response?.data?.data);
      setTotalCount(response?.data?.totalPages || 0);
    } catch (error) {
      console.error('Error fetching chat details:', error);
    }
  }
  useEffect(() => {
    getChatsDetails();
  }, [page]);

  return (
    <div className="mx-auto" style={{ maxHeight: '80vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '12px', padding: '4px 2px' }}>
      {message.map((msg) => (
        <div key={msg.id}>
          {msg.type === 'email' || msg.type === 'subEmail' || msg.type === 'notification' ? (
            <NotificationMessage text='BuCountry Tours was notified via Email.' timestamp={msg.createdAt} message={msg.body} />
          ) : (
            <UserMessage
              avatar={msg.participantName.charAt(0).toUpperCase()}
              name={msg.participantName}
              timestamp={msg.createdAt}
              message={msg.message}
            />
          )}
        </div>
      ))}
      {totalPages > 1 && (
        <>
          <div style={{ marginTop: "20px" }}>
            <ResponsivePagination
              current={page}
              total={totalCount}
              onPageChange={setPage}
            />
          </div>
        </>
      )}
    </div>
  );
}

function NotificationMessage({ text, timestamp, message }) {
  const formatMailBody = (body) => {
    if (!body) return '';
    let cleanBody = body;

    cleanBody = cleanBody.replace(/<div<br\/>/gi, '<div><br/>');
    cleanBody = cleanBody.replace(/<\/div<br\/>/gi, '</div><br/>');
    cleanBody = cleanBody.replace(/<a href="([^"]*)"<br\/>/gi, '<a href="$1">');

    const pattern = /(On .*wrote:)/gi;
    cleanBody = cleanBody.replace(
      pattern,
      `<br/><span style="font-size:13px; color:#6a6a6a;">$1</span>` +
      `<blockquote style="margin:0 0 0 .8ex; border-left:1px solid #ccc; padding-left:1ex; color:#202124;">`
    );

    cleanBody = cleanBody.replace(/<\/a<br\/>/gi, '</a><br/>');
    cleanBody = cleanBody.replace(/<blockquote<br\/>/gi, '<blockquote style="margin:0 0 0 .8ex; border-left:1px solid #ccc; padding-left:1ex; color:#202124;">');
    cleanBody = cleanBody.replace(/<\/blockquote<br\/>/gi, '</blockquote>');
    cleanBody = cleanBody.replace(/<span<br\/>/gi, '<span style="font-size:13px; color:#444;">');
    cleanBody = cleanBody.replace(/<\/span<br\/>/gi, '</span>');

    cleanBody = cleanBody.replace(/ontainer"\s*<br\/>/gi, '');
    cleanBody = cleanBody.replace(/<blockquote class="gmail_quote"[^>]*>/gi, ' ');
    cleanBody = cleanBody.replace(/<\/blockquote>/gi, ' ');
    cleanBody = cleanBody.replace(/<div class="gmail_quote[^<]*/gi, '');
    cleanBody = cleanBody.replace(/<div class="gmail_quote[^>]*>[\s\S]*?<\/div>/gi, '');
    cleanBody = cleanBody.replace(/<div class="gmail_attr[^>]*>[\s\S]*?<\/div>/gi, '');

    cleanBody = cleanBody.replace(/<div[^>]*>\s*(?:<br\s*\/?>\s*)*<\/div>/gi, '');
    cleanBody = cleanBody.replace(/<p[^>]*>\s*(?:<br\s*\/?>\s*)*<\/p>/gi, '');

    cleanBody = cleanBody.replace(/(\r\n|\r|\n)/g, '<br/>');
    cleanBody = cleanBody.replace(/(<br\s*\/?>\s*){2,}/gi, '<br/>');
    cleanBody = cleanBody.replace(/^(<br\s*\/?>\s*)+/i, '');
    cleanBody = cleanBody.replace(/(<br\s*\/?>\s*)+$/i, '');

    cleanBody = cleanBody.trim();
    return cleanBody;
  };
  return (
    <div style={{ background: '#f0faf4', border: '1px solid #b7e4c7', borderRadius: '10px', padding: '14px 16px' }}>
      <div className="flex items-start gap-3">
        <Info style={{ color: '#1a7d3e', flexShrink: 0, marginTop: '2px' }} className="h-5 w-5" />
        <div className="flex-1">
          <p className="text-sm font-medium" style={{ color: '#1a7d3e' }}>{text}</p>
          {timestamp && <p className="text-xs mt-1" style={{ color: '#6b7280' }}>{timestamp}</p>}
        </div>
      </div>
      <div
        className="text-sm whitespace-pre-wrap msg-thread-body"
        style={{ marginTop: '10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px', color: '#374151', lineHeight: '1.6' }}
        dangerouslySetInnerHTML={{ __html: formatMailBody(message) || '' }}
      />
    </div>
  );
}

function UserMessage({ avatar, name, timestamp, message }) {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0">
        <div
          className="h-10 w-10 rounded-full flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}
        >
          <span className="text-white font-semibold text-sm">{avatar}</span>
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="font-semibold" style={{ color: '#1a7d3e', fontSize: '14px' }}>{name}</p>
          <span className="text-xs" style={{ color: '#9ca3af' }}>{timestamp}</span>
        </div>
        <div
          className="text-sm whitespace-pre-wrap"
          style={{ marginTop: '8px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px', color: '#374151', lineHeight: '1.6' }}
        >
          {message}
        </div>
      </div>
    </div>
  );
}
